import React, { useState, useEffect, useContext, useRef } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
// import AxiosInstance from "../utils/AxiosInstance";
import DefaultRadioTwelve from "./child/DefaultRadioTwelve";
import UnitCountEight from "./child/UnitCountEight";
import FilterContext from "../utils/FilterContext";
import { useConfig } from "../utils/ConfigContext.jsx";
import {createAxiosInstance} from "../utils/AxiosInstance.jsx";


const columnWidths = [
  "40px", "200px", "150px", "120px", "140px", "140px", "140px", "140px",
  "140px", "140px", "120px", "150px", "200px", "200px", "200px",
];

const Row = ({ data, className = "", variant = "default" }) => {
  const variantClass = {
    header: "bg-white fw-bold border text-dark ",
    accordion: "bg_sky text-primary fs-6 border border-light",
    body: "bg-white text-dark border ",
  }[variant];

  const getZIndex = () => {
    if (variant === "header") return 30;
    if (variant === "accordion") return 20;
    return 10;
  };

  const getBackground = () => {
    if (variant === "header") return "white"; // Only header gets white background
    return "inherit"; // Others stay as-is (from their class like bg_sky or bg-white)
  };


  return (
    <div className={
      `d-flex text-center ${variantClass} ${className}`} style={{
        position: variant === "header" ? "sticky" : "static",
        top: variant === "header" ? 0 : "auto",
        zIndex: variant === "header" ? 100 : "auto",
        background: variant === "header" ? "white" : "inherit",
      }}>
      {data.map((cell, index) => {
        const isSticky = index < 4;
        const left = columnWidths.slice(0, index).reduce((acc, w) => acc + parseInt(w), 0);
        return (<div
          key={index}
          style={{
            width: columnWidths[index],
            fontSize: "14px",
            position: isSticky ? "sticky" : "static",
            left: isSticky ? `${left}px` : "auto",
            zIndex: isSticky ? getZIndex() : "auto",
            background: isSticky ? getBackground() : "inherit",
            borderRight: "1px solid #dee2e6",

          }}
          className="p-2 border-end"
        >
          {cell}
        </div>)
      })}
    </div>
  );
};

const DashBoardLayerTest = () => {
  const { API_BASE_URL } = useConfig(); // ✅ from context
  const AxiosInstance = createAxiosInstance(API_BASE_URL);
  // get date form filter
  const { filters } = useContext(FilterContext);
  const filtersRef = useRef(filters);
  const [summaryHeader, setSummaryHeader] = useState([]);
  const [tableBodyData, setTableBodyData] = useState([]);
  const [totalSummary, setTotalSummary] = useState({
    totalAppointments: 0,
    totalBookedSnb: 0,
    totalBookedSdt: 0,
    totalPackagePrice: 0,
    totalReceivedAmount: 0,
    totalDiscount: 0,
  });
  const [openPanels, setOpenPanels] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [isModalLoading, setIsModalLoading] = useState(false);

  useEffect(() => {
    if (filtersRef.current !== filters) {
      // console.log("filtersRef.current", filtersRef.current)
      // console.log("ghus gya")
      filtersRef.current = filters;
      // console.log("date change", filters)
      getStateValue([null, true, false, false]);


    }
  }, [filters]);

  const getStateValue = async (getStateValueArray) => {
    setIsLoading(true)
    // console.log("getStateValueArray", getStateValueArray);
    const checked = getStateValueArray.map((v, k) => v ? k : null).filter(k => k !== null);
    // console.log("checked", checked);
    try {

      // Get first and last date of the previous month
      const now = new Date();
      const firstDayLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const lastDayLastMonth = new Date(now.getFullYear(), now.getMonth(), 0);

      // Format date as YYYY-MM-DD
      const pad = (n) => n.toString().padStart(2, '0');
      const formatDate = (date) =>
        // `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
        `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()}`;

      let startDate = formatDate(firstDayLastMonth);
      let endDate = formatDate(lastDayLastMonth);
      // function for change YYYY-MM-DD TO DD-MM-YYYY
      const convertToDDMMYYYY = (dateStr) => {
        const [year, month, day] = dateStr.split("-");
        return `${day}-${month}-${year}`;
      };

      // const filters = filtersRef.current;
      // console.log("date", filters);
      if (filters?.dateRange) {
        const [start, end] = filters.dateRange.split(" - ");
        if (start && end) {
          startDate = convertToDDMMYYYY(start.trim());
          endDate = convertToDDMMYYYY(end.trim());
        }
      }
      const response = await AxiosInstance.post("/doctors/revenue", {
        startdate: startDate,
        enddate: endDate,
        doc_type: filters.doctorName.id
      });

      const { state_summary, data, summary } = response.data;

      setSummaryHeader(state_summary || []);
      setTableBodyData(data || []);
      setTotalSummary({
        totalAppointments: summary.Total_Appointments,
        totalBookedSnb: summary.Booked_Detox,
        totalBookedSdt: summary.Booked_EECP,
        totalPackagePrice: summary.Total_Package_Price,
        totalReceivedAmount: summary.Received_Amount,
        totalDiscount: summary.Total_Discount,
      });
      setIsLoading(false)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const togglePanel = (stateKey) => {
    setOpenPanels((prev) => ({
      ...prev,
      [stateKey]: !prev[stateKey],
    }));
  };

  const getSlug = (str) => str.replace(/\s+/g, "_").toLowerCase();

    // 🔹 Export Excel Function
 const exportToExcel = () => {
  
  const exportData = [];

  // Table Header
  exportData.push([
    "State / Center",
    "Assistant Doctor",
    "Month",
    "Appointments",
    "OPD Patient",
    "Advised (SNB)",
    "Advised (SDT)",
    "Booked (SNB)",
    "Booked (SDT)",
    "Treatment Patient",
    "Package Price",
    "Received Amount(New)",
    "Received Amount(Old)",
    "Total Received Amount",
  ]);

  summaryHeader.forEach((summary) => {
    // 🔹 Add State summary row
    exportData.push([
      summary.State, // State Name
      summary.Assistant_Doctor ?? "-",
      summary.Report_Month,
      summary.Total_Appointments,
      summary.Unique_Patient,
      summary.Advised_EECP,
      summary.Advised_Detox,
      summary.Booked_EECP,
      summary.Booked_Detox,
      summary.Total_Patients,
      summary.Total_Package_Price,
      summary.Received_Amount,
      summary.Old_Patient_Amount,
      summary.Total_Total_Price,
    ]);

    // 🔹 Add its Center rows (hospital data)
    const centers = tableBodyData.filter((row) => row.State === summary.State);

    centers.forEach((row, i) => {
      exportData.push([
        "   → " + row.Hospital_Name, // Indent under state
        row.Assistant_Doctor,
        row.Report_Month,
        row.Total_Appointments,
        row.Unique_Patient,
        row.Advised_EECP,
        row.Advised_Detox,
        row.Booked_EECP,
        row.Booked_Detox,
        row.Total_Patients,
        row.Total_Package_Price,
        row.Received_Amount,
        row.Old_Patient_Amount,
        row.Total_Total_Price,
      ]);
    });

    // Blank line after each state group
    exportData.push([]);
  });

  // Convert to Excel sheet
  const ws = XLSX.utils.aoa_to_sheet(exportData);
  const wb = XLSX.utils.book_new();

  const doctorName =
  typeof filtersRef.current.doctorName === "string"
    ? filtersRef.current.doctorName
    : filtersRef.current.doctorName?.label || "Doctor";

  const safeSheetName = `${doctorName}_Revenue`
    .replace(/[:\\/?*\[\]]/g, "")  // remove invalid chars
    .slice(0, 31);

  XLSX.utils.book_append_sheet(wb, ws, safeSheetName);

  // Save
  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${safeSheetName}.xlsx`);
};

  const fetchAppointmentDetails = async (centerId, doctorId, title) => {
    // Show modal and start loading
    setShowModal(true);
    setIsModalLoading(true);
    setModalTitle(title);

    try {
      const now = new Date();
      const pad = (n) => n.toString().padStart(2, "0");
      const formatDate = (date) =>
        `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()}`;

      let startDate = formatDate(new Date(now.getFullYear(), now.getMonth() - 1, 1));
      let endDate = formatDate(new Date(now.getFullYear(), now.getMonth(), 0));

      if (filters?.dateRange) {
        const [start, end] = filters.dateRange.split(" - ");
        const convertToDDMMYYYY = (dateStr) => {
          const [year, month, day] = dateStr.split("-");
          return `${day}-${month}-${year}`;
        };
        startDate = convertToDDMMYYYY(start.trim());
        endDate = convertToDDMMYYYY(end.trim());
      }
      
      const response = await AxiosInstance.post("/doctors/revenue_details", {
        start_date: startDate,
        end_date: endDate,
        center_id: centerId,
        doctor_id: doctorId,
      });

      setModalData(response.data.data || []);
    } catch (error) {
      console.error("Error fetching appointment details:", error);
    } finally {
      // Hide spinner after data is fetched or on error
      setIsModalLoading(false);
    }
  };



  return (
    <>
      {/* <DefaultRadioTwelve getStateValue={getStateValue} /> */}
      <UnitCountEight totalSummary={totalSummary} />
      {/* 🔹 Export Button */}
      <div className="mb-2 d-flex justify-content-end">
        <button onClick={exportToExcel} className="btn btn-success">
          Export to Excel
        </button>
      </div>
      <div className="DailyReportTableTest" style={{ position: "relative" }}>
        <div style={{ overflow: "auto", maxHeight: "500px", position: "relative", transform: "translateZ(0)" }}>
          <div style={{ minWidth: "2220px" }}>
            {/* Table Header */}
            <Row
              data={[
                "#", "Center Name", "Doctor", "Month", "Appointments", "OPD Patient",
                "Advised (SNB)", "Advised (SDT)", "Booked (SNB)", "Booked (SDT)",
                "Treatment Patient", "Package Price", "Received Amount(New)", "Received Amount(Old)", "Total Received Amount",
              ]}
              variant="header"
            />
            {isLoading ? (<div className="d-flex align-items-center justify-content-start">
              <div className="loader"></div>
            </div>) : (
              <>
                {/* Accordion Rows */}
                < div className="accordion" id="accordionExample">
                  {summaryHeader.map((summary, index) => {
                    const {
                      State,
                      Assistant_Doctor,
                      Report_Month,
                      Total_Appointments,
                      Unique_Patient,
                      Advised_EECP,
                      Advised_Detox,
                      Booked_EECP,
                      Booked_Detox,
                      Total_Patients,
                      Total_Package_Price,
                      Received_Amount,
                      Old_Patient_Amount,
                      Total_Total_Price,
                      report_count
                    } = summary;

                    const stateKey = getSlug(State);
                    const isOpen = openPanels[stateKey];
                    const isDisabled = report_count === 0;

                    const filteredData = tableBodyData.filter(
                      (row) => row.State === State
                    );


                    return (

                      <div
                        className={`accordion-item ${isDisabled ? "disabled-section" : ""}`}
                        key={stateKey}
                      >
                        <div className="accordion-header" id={`heading_${stateKey}`}>
                          <div
                            className={`accordion-button bg_sky ${isOpen ? "" : "collapsed"}`}
                            style={{ padding: 0, border: "none", fontSize: "15px", fontWeight: "600" }}
                            onClick={() => !isDisabled && togglePanel(stateKey)}
                          >
                            <Row
                              data={[
                                index + 1,
                                State,
                                Assistant_Doctor ?? "-", // fallback if missing
                                Report_Month,
                                Total_Appointments,
                                Unique_Patient,
                                Advised_EECP,
                                Advised_Detox,
                                Booked_EECP,
                                Booked_Detox,
                                Total_Patients,
                                Total_Package_Price,
                                Received_Amount,
                                Old_Patient_Amount,
                                Total_Total_Price
                              ]}
                              variant="accordion"
                            />
                          </div>
                        </div>

                        <div
                          id={`collapse_${stateKey}`}
                          className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
                          aria-labelledby={`heading_${stateKey}`}
                        >
                          <div className="accordion-body p-0">
                            {filteredData.length === 0 ? (
                              <div className="text-center p-2">No data available</div>
                            ) : (
                              filteredData.map((rowData, i) => (
                                <Row
                                  key={i}
                                  data={[
                                    i + 1,
                                    rowData.Hospital_Name,
                                    rowData.Assistant_Doctor,
                                    rowData.Report_Month,
                                   <span
                                      key={`appointments-${i}`}
                                      style={{
                                        cursor: "pointer",
                                        color: "blue",
                                        textDecoration: "underline",
                                      }}
                                      onClick={() =>
                                        fetchAppointmentDetails(
                                          rowData.hm_id,
                                          rowData.um_id,
                                          `Appointments - ${rowData.Hospital_Name}`
                                        )
                                      }
                                    >
                                      {rowData.Total_Appointments}
                                    </span>,
                                    rowData.Unique_Patient,
                                    rowData.Advised_EECP,
                                    rowData.Advised_Detox,
                                    rowData.Booked_EECP,
                                    rowData.Booked_Detox,
                                    rowData.Total_Patients,
                                    rowData.Total_Package_Price,
                                    rowData.Received_Amount,
                                    rowData.Old_Patient_Amount,
                                    rowData.Total_Total_Price,
                                  ]}
                                  variant="body"
                                />
                              ))
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}

          </div>
        </div>
      </div >
      {showModal && (
        <>
          <div className="modal-backdrop fade show w-100 h-100"></div>
          <div
            className="modal d-block"
            tabIndex="-1"
            style={{ position: "fixed", overflowY: "auto" }}
          >
            <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{modalTitle}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  {isModalLoading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                  ) : modalData.length === 0 ? (
                    <p>No appointments found.</p>
                  ) : (
                    <div>
                      <table className="table table-bordered">
                        <thead
                          style={{
                            position: "sticky",
                            top: -18,
                            backgroundColor: "white",
                            zIndex: 1,
                          }}
                        >
                          <tr>
                            <th>#</th>
                            <th>Patient Name</th>
                            <th>Patient ID</th>
                            <th>Appointment Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {modalData.map((item, idx) => (
                            <tr key={idx}>
                              <td>{idx + 1}</td>
                              <td>{item.patient_name}</td>
                              <td>{item.patient_unique_id}</td>
                              <td>{item.appointment_date}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default DashBoardLayerTest;
